"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SSFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_214)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_214`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0.000305176H35.64V23.9998H-0.359985V0.000305176Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 16.6957H35.64V23.9998H-0.359985V16.6957Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0.000305176H35.64V7.34902H-0.359985V0.000305176Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 8.82733H35.64V15.1313H-0.359985V8.82733Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.64 12.0005L-0.359985 24.0002V-0.00012207L17.64 12.0005Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.78533 8.70856L6.25002 10.7523L8.64655 9.99085L7.15543 12.0155L8.62004 14.0594L6.2337 13.2669L4.74251 15.2915L4.75897 12.777L2.37256 11.9843L4.76902 11.2229L4.78533 8.70856Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_214`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SSFlag };
